// Animation constants for consistent motion design
export const ANIMATION_CONSTANTS = {
  // Standard durations
  DURATION: {
    FAST: 0.3,
    NORMAL: 0.5,
    SLOW: 0.8,
  },
  
  // Standard delays
  DELAY: {
    NONE: 0,
    SHORT: 0.1,
    MEDIUM: 0.2,
    LONG: 0.3,
  },
  
  // Standard Y offsets for entrance animations
  OFFSET: {
    SMALL: 20,
    MEDIUM: 30,
    LARGE: 50,
  },
  
  // Standard easing curves
  EASING: {
    EASE_OUT: "easeOut",
    EASE_IN_OUT: "easeInOut",
    EASE_IN: "easeIn",
  },
  
  // Standard stagger delays
  STAGGER: {
    FAST: 0.05,
    NORMAL: 0.1,
    SLOW: 0.2,
  },
};

// Standard animation variants
export const STANDARD_VARIANTS = {
  // Container animations
  container: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATION.NORMAL,
        staggerChildren: ANIMATION_CONSTANTS.STAGGER.NORMAL,
        ease: ANIMATION_CONSTANTS.EASING.EASE_OUT,
      },
    },
  },
  
  // Item animations with small offset
  item: {
    hidden: { 
      opacity: 0, 
      y: ANIMATION_CONSTANTS.OFFSET.SMALL 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATION.NORMAL,
        ease: ANIMATION_CONSTANTS.EASING.EASE_OUT,
      },
    },
  },
  
  // Item animations with medium offset
  itemMedium: {
    hidden: { 
      opacity: 0, 
      y: ANIMATION_CONSTANTS.OFFSET.MEDIUM 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATION.NORMAL,
        ease: ANIMATION_CONSTANTS.EASING.EASE_OUT,
      },
    },
  },
  
  // Item animations with large offset for major sections
  itemLarge: {
    hidden: { 
      opacity: 0, 
      y: ANIMATION_CONSTANTS.OFFSET.LARGE 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: ANIMATION_CONSTANTS.DURATION.SLOW,
        ease: ANIMATION_CONSTANTS.EASING.EASE_OUT,
      },
    },
  },
};

// Standard hover animations
export const HOVER_ANIMATIONS = {
  scale: {
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 },
    transition: { duration: ANIMATION_CONSTANTS.DURATION.FAST },
  },
  
  subtle: {
    whileHover: { scale: 1.02 },
    whileTap: { scale: 0.98 },
    transition: { duration: ANIMATION_CONSTANTS.DURATION.FAST },
  },
};